import { matchPath } from 'react-router-dom'

const PGA_COACH_HIDDEN_LAUNCHER_PATHS = [
  '/pga-coach/bookings/booking-types',
  '/pga-coach/bookings/events',
]

const PGA_COACH_VISIBLE_LAUNCHER_PATHS = [
  '/pga-coach/profile',
  '/pga-coach/settings',
  '/pga-coach/bookings',
  '/pga-coach/leads',
  '/pga-coach/student',
]

const STANDALONE_VISIBLE_LAUNCHER_PATHS = [
  '/invitation/:connectionId',
  '/payment/:paymentRequestToken',
  '/checkout/success',
  '/pga-coach/profile/new',
]

const matchesPath = (pathname, path, exact = false) =>
  !!matchPath(pathname, { path, exact })

export const shouldShowPgaCoachIntercomLauncher = pathname => {
  if (matchesPath(pathname, '/pga-coach', true)) return true
  if (
    PGA_COACH_HIDDEN_LAUNCHER_PATHS.some(path =>
      matchesPath(pathname, path, true),
    )
  ) {
    return false
  }

  return PGA_COACH_VISIBLE_LAUNCHER_PATHS.some(path =>
    matchesPath(pathname, path),
  )
}

export const shouldShowStandaloneIntercomLauncher = pathname =>
  STANDALONE_VISIBLE_LAUNCHER_PATHS.some(path =>
    matchesPath(pathname, path, true),
  )
